import { render, staticRenderFns } from "./MAnpassung.vue?vue&type=template&id=97a50b6a&scoped=true&"
import script from "./MAnpassung.vue?vue&type=script&lang=js&"
export * from "./MAnpassung.vue?vue&type=script&lang=js&"
import style0 from "./m-wms.scss?vue&type=style&index=0&id=97a50b6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a50b6a",
  null
  
)

export default component.exports